import { Box, Button, Heading, Image, Input, Select, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import Footer from '../Common/Footer'
import MarketingPageAccordation from '../Common/MarketingPageAccordation'

function Commerce() {
    const faqs = [
        {
            que:"What payment methods does Mailchimp accept?",
            ans:"We accept all major credit cards, PayPal, and (in select countries) direct debit. We also support transactions in a range of currencies."
        },
        {
            que:"How much does it cost to sell from a Mailchimp online store?",
            ans:"There are 2 types of fees for transactions on stores. First, each transaction includes a %-based transaction fee, based on your monthly plan and total order value. We also partner with Stripe to process payments; Stripe charges fees based on your location."
        },
        {
            que:"Can I connect my existing domain to a Mailchimp website?",
            ans:"Yes. If you own a domain through Mailchimp or a third-party service, you can connect it to your online store with a Core or Plus Websites & Commerce plan."
        },
        {
            que:"Are Mailchimp online stores available in my country?",
            ans:"Stores are currently only supported in the United States and United Kingdom. Any Mailchimp user can explore the feature and set up a Store, but only users who have businesses based in the UK and the US can publish a store and sell products."
        },
        {
            que:"How do I switch to a different plan?",
            ans:"You can switch to a new plan at any time by going to the Billing page in your account. Select the plan you’d like to switch to and immediately start using new features."
        },
    ]
    const related_links =[
        {
          to:'/',
          title:'E-commerce'
        },
        {
          to:'/',
          title:'Online Payments 101: How to Start Selling with Square'
        },
        {
          to:'/',
          title:'How To Start an E‑Commerce Business—a Complete Guide'
        }
     ]
  return (
    <>
        <Box mt="4rem">
            <Box w="80%"  display="flex" justifyContent="right">
            <Select w="9%" fontWeight="bold" color="teal" borderColor="transparent">
                <option  value='option1'>₹ INR</option>
                <option  value='option2'>$ USD</option>
            </Select>
            </Box>
            <Box  w="80%" textAlign="left" display="flex" justifyContent="center">
                <Box w="32%" p="4rem 1rem 2rem 2rem" border="1px solid grey">
                    <VStack spacing={4} align="stretch">
                        <Heading as="h1" size="2xl"  fontWeight="400">Plus</Heading>
                        <Text>All websites & commerce features and our lowest transaction fees for scaling businesses.</Text>
                        <Text >Starts at<br/><Box display="flex">₹<Heading>2,334</Heading>.07*</Box>/month*</Text>
                        <Text w="70%">+ .5% transaction free and Stripe processing fees*</Text>
                        <Button colorScheme='teal' p="0rem 35%" size="lg" >Buy Now</Button>
                    </VStack>
                </Box>
                <Box w="32%" p="4rem 1rem 2rem 2rem" border="1px solid grey">
                    <VStack spacing={4} align="stretch">
                        <Heading as="h1" size="2xl"  fontWeight="400">Plus</Heading>
                        <Text>Website customization, 24/7 support, and lower transaction fees for growing businesses.</Text>
                        <Text >Starts at<br/><Box display="flex">₹<Heading>804</Heading>.07*</Box>/month*</Text>
                        <Text w="70%">+ 1.5% transaction fee and Stripe processing fees*</Text>
                        <Button colorScheme='teal' p="0rem 35%" size="lg" >Buy Now</Button>
                    </VStack>
                </Box>
                <Box w="32%" p="4rem 1rem 2rem 2rem" border="1px solid grey">
                    <VStack spacing={4} align="stretch">
                        <Heading as="h1" size="2xl"  fontWeight="400">Plus</Heading>
                        <Text>Everything businesses need to build a website and launch a store.</Text>
                        <br />
                        <Text >Starts at<br/><Box display="flex">₹<Heading>0</Heading>.07*</Box>/month*</Text>
                        <Text w="70%">+ 2% transaction fee and Stripe processing fees*</Text>
                        <Button colorScheme='teal' p="0rem 35%" size="lg" >Buy Now</Button>
                    </VStack>
                </Box>
            </Box>
            <Button mt="8" variant="outline" colorScheme="teal">Compare Our Plan</Button>
            <Text w="65%" mt="4rem" display="block" >*All Websites & Commerce plans include access to our Mailchimp stores product. If you create and publish a store, transaction fees will be charged to you on a per transaction basis based on the total order value (minus promotions and discounts, plus tax and shipping) for each transaction. These transaction fees are non-refundable. You will also be charged fees by Stripe. See <Button variant="link" colorScheme="teal">Stripe.com</Button> for details about Stripe fees.</Text>
            <Box bgColor="#f6f6f4" m="4rem 0rem" p="4rem 0rem">
                <Box>
                    <VStack spacing={6} >
                        <Heading as="h5" fontSize="24px">Featured Product:</Heading>
                        <Text w="50%">Create unlimited one-on-one and group services with our new <Button variant="link" colorScheme="teal">Advanced Scheduling</Button> add-on for $8/month.</Text>
                        <Button variant="solid" colorScheme="teal" p="2rem 2rem" >Buy Now</Button>
                    </VStack>
                </Box>   
            </Box>
            <Box width="80%" margin="4rem auto" display="flex" p="2rem 1rem" justifyContent="space-evenly" alignItems={"center"}>
                <Box>
                    <Image width="400px" src="https://eep.io/images/yzco4xsimv0y/3PN7I87VPcAzVXe6iMYLct/5a1300742c23f2e01ad572273285c143/pricing.png?w=760&fm=webp&q=80" alt=""/>
                </Box>
                <Box textAlign="left" w="40%">
                    <Heading as="h1" mb={8} size="xl" fontWeight="400">Also included: Free, built-in marketing tools</Heading>
                    <Text mb="8" w="90%">All Websites & Commerce plans come with <Button variant="link"colorScheme="teal">Free marketing features</Button> like email and social posting, so you can find new customers and drive sales. But if you want more advanced marketing tools, like our <Button variant="link"colorScheme="teal">Customer Journey Builder,</Button>  try a paid Marketing plan.</Text>
                    <Button colorScheme='teal' variant='outline' p={8}>Explore Marketing plans</Button>
                </Box>
            </Box>
            <Box bgColor="#c5dbf2" p="4rem 0">
                <Heading>Add on powerful features</Heading>
                <br />
                <Box>
                    <Box bgColor="white" w="70%" p="6rem 4rem" display="flex" justifyContent="space-between">
                        <Box textAlign="left" w="40%">
                            <Heading as="h1" mb={8} size="xl" fontWeight="400">Add on a domain</Heading>
                            <Text >Buy a custom domain to help people find you on the web. Plus, a consistently branded online presence builds trust across email and other channels. Choose from over 200 domain extensions, including .com, .org, and .net.</Text>
                            <Box mt="2rem" ><Input height="60px" borderColor="black" fontSize="28px" p="1rem 1.5rem" placeholder="Start Your Search Here" /></Box>
                            <Button mt="2rem" variant="solid" colorScheme="teal" color="white" p="1rem 3rem">Find Your Domain</Button>
                        </Box>
                        <Box>
                            <Image width="400px" src="https://eep.io/images/yzco4xsimv0y/4yOflc1XUIZF81NnLz05jC/685616b38b9b5e24d9b15f1461409f80/AUI_Custom-Domains_Eyewear_v2_1520.png" alt=""/>
                        </Box>
                    </Box>
                    <Box w="70%" p="1rem 2rem" bgColor="#f6f6f4" display="flex"  justifyContent="space-between">
                        <Image w="280px" height="40px" src="https://eep.io/images/yzco4xsimv0y/azFGj9nAkrFqZwtlOxrOO/c7633a0a233acbff0941c35632f69ebc/google-workspace.png" alt=""/>
                        <Text w="65%" textAlign="left">Add Google Workspace to your domain purchase to get a custom email address and team collaboration tools like Google Drive, Sheets, and Slides.</Text>
                    </Box>
                </Box>
            </Box>
            <Box mt="4rem">
                <Box display="flex" justifyContent="center"  >
                    <Box width="41%" borderRight="1px solid" textAlign="left" p="0rem 3rem 2rem 1rem">
                        <Heading mb="2rem">Two-factor authentication discount</Heading>
                        <Text mb="2rem">At Mailchimp, we’re serious about security. We offer a 10% discount for 1 month when you add two-factor authentication to your Mailchimp account with an app like Google Authenticator or SMS two-factor authentication.</Text>
                        <Text mb="2rem">Restrictions apply. See our full <Button variant="link" colorScheme="teal">terms and conditions.</Button></Text>
                        <Button variant="outline" p="1rem 3rem" colorScheme="teal">Get Started</Button>
                    </Box>
                    <Box width="40%" borderLeft="1px solid" textAlign="left" p="0rem 1rem 2rem 3rem">
                        <Heading mb="2rem">Rates for nonprofits and charities</Heading>
                        <Text mb="5rem">Mailchimp offers a 15% discount to nonprofits and charities. To request the discount, sign up for a free account, and contact our Billing team with your username and a link to your organization’s website.</Text>
                        <Button variant="outline" p="1rem 3rem" colorScheme="teal">Get Started</Button>
                    </Box>
                </Box>
            </Box>
            <Box bgColor="#f6f6f4" margin="4rem auto" display="flex" p="4rem 0rem" justifyContent="space-evenly" alignItems={"center"}>
                <Box>
                    <Image width="400px" src="https://eep.io/images/yzco4xsimv0y/6rMAO0ldN6imaGyWo68a04/835f8130a3279eb3c68a334f452ddd2f/ILLO_Spot_Mailchimp_Agencies_1080.png?w=540&fm=webp&q=80" alt=""/>
                </Box>
                <Box textAlign="left" w="40%">
                    <Heading as="h1" mb={8} size="xl" fontWeight="400">Need to help clients use Mailchimp?</Heading>
                    <Text mb="8" w="90%">Unlock the tools you need to get work done for clients when you sign up through Mailchimp & Co, our community for freelancers and agencies. It’s free to join with any Mailchimp plan.</Text>
                    <Button colorScheme='teal' variant='outline' p="1rem 2rem">Get Started</Button>
                </Box>
            </Box>
            <Box width="70%" mt="8rem">
                <Heading display="flex" mb={4}>FAQ'S</Heading>
                <MarketingPageAccordation data={faqs}/>
            </Box>
            <Footer related_links={related_links}/>
        </Box>
    </>
  )
}

export default Commerce